import { html, nothing, type TemplateResult } from "lit";
import { icons } from "../icons.ts";
import { ref } from "lit/directives/ref.js";
import type { FleetSlashCommand } from "./fleet-slash-commands.ts";
import { filterSlashCommands } from "./fleet-slash-commands.ts";

export type SlashCommandPickerProps = {
  commands: FleetSlashCommand[];
  query: string;
  activeIndex: number;
  onSelect: (command: FleetSlashCommand) => void;
  onHoverIndex: (index: number) => void;
  /** Close the picker (e.g. via the X button). Host removes
   *  the triggering `/` token from the draft. */
  onClose?: () => void;
};

export function renderSlashCommandPicker(props: SlashCommandPickerProps) {
  const matches = filterSlashCommands(props.commands, props.query);
  if (matches.length === 0) {
    return nothing;
  }
  const effectiveIndex = Math.max(0, Math.min(props.activeIndex, matches.length - 1));
  return html`
    <div class="chat-slash-wrap">
      <div class="chat-slash-header">
        <span class="chat-slash-header__title">Commands</span>
        ${props.onClose
          ? html`<button
              type="button"
              class="chat-slash-header__close"
              title="Close command picker"
              aria-label="Close command picker"
              @click=${() => props.onClose?.()}
            >
              ${icons.x}
            </button>`
          : nothing}
      </div>
      <div class="chat-slash" role="listbox" aria-label="Slash commands">
        ${matches.map((command, index) => {
        const active = index === effectiveIndex;
        return html`
          <button
            type="button"
            class="chat-slash__row ${active ? "active" : ""}"
            role="option"
            aria-selected=${active}
            ${ref((el) => {
              if (active && el) {
                (el as HTMLElement).scrollIntoView({
                  block: "nearest",
                  inline: "nearest",
                });
              }
            })}
            @mousedown=${(e: Event) => e.preventDefault()}
            @mouseenter=${() => props.onHoverIndex(index)}
            @click=${() => props.onSelect(command)}
          >
            <span class="chat-slash__name mono">/${command.name}</span>
            <span class="chat-slash__desc">${command.description}</span>
          </button>
        `;
      })}
      </div>
    </div>
  `;
}
